import React, { useState } from "react";
import Login from "./Login";
import RequestAccess from "./RequestAccess";

const LoginRequest = ({ loginSubmit, errorUser, showLoader }) => {
  const [isReqAccess, setIsReqAccess] = useState(false);

  const handleRequestClick = () => {
    setIsReqAccess(true);
  };
  const handleRequestCloseClick = () => {
    setIsReqAccess(false);
  };
  return (
    <div className="login-container">
      {isReqAccess ? (
        <RequestAccess
          handleClose={handleRequestCloseClick}
          showLoader={showLoader}
        />
      ) : (
        <Login
          loginSubmit={loginSubmit}
          handleRequestClick={handleRequestClick}
          errorUser={errorUser}
        />
      )}
    </div>
  );
};

export default LoginRequest;
